import { Action, ActionFunction1 } from "redux-actions";
import { call, put, select } from "redux-saga/effects";
import { api } from "../../../dependencies";
import { Creators } from "../../../actions/common";
import { SagaFunction } from "../../../actions/types";
import { AxiosInterceptedResult } from "../../../api/interceptors";
import { IResolveResponse } from "../../../api/ResolveApi/resolve-api.types";
import {
  modifyObjectDeletedPatch,
  patchPayloadCreator,
} from "../../../components/course-author/helpers/patches/creators";
import { SagaAction } from "../../../sagas/types";
import * as selectors from "../../../selectors/selectors";

interface IFurtherActions {
  onFailure: ActionFunction1<{ message: string }, Action<{ message: string }>>;
  onSuccess: ActionFunction1<void, Action<void>>;
}

export const deleteAccount = (fa: IFurtherActions): SagaFunction =>
  function* _deleteAccount(action: Action<string>): SagaAction {
    const currentAccountId: string = yield select(selectors.accountId);
    const [resolveError, resolveResp]: AxiosInterceptedResult<Array<
      IResolveResponse<{ versionId: number }>
    >> = yield call(api.resolve.account.post, currentAccountId, [action.payload]);
    if (resolveError || resolveResp === null || !resolveResp.data.length) {
      yield put(fa.onFailure({ message: "Error when resolving account" }));
      return null;
    }
    const versionId = resolveResp.data[0].value.versionId;
    const deletePatch = modifyObjectDeletedPatch(versionId, currentAccountId);
    const patchPayload = patchPayloadCreator(versionId, deletePatch);

    const [patchError]: AxiosInterceptedResult<{}> = yield call(
      api.users.patchAccount,
      currentAccountId,
      action.payload,
      patchPayload
    );
    if (patchError) {
      yield put(fa.onFailure({ message: "Error when patching account" }));
      return null;
    }
    yield put(Creators.loadUsersAmount());
    yield put(fa.onSuccess());
  };
